export const CONTACT = {
  phoneDisplay: "+91 82333 32960",
  phoneHref: "tel:+918233332960",
  phone2Display: "+91 63636 57669",
  phone2Href: "tel:+916363657669",
  phoneUsDisplay: "+1 760 606 1623",
  phoneUsHref: "tel:+17606061623",
  whatsapp: "https://wa.me/918233332960",
  email: "info@celestraone.com",
  website: "www.celestraone.com",
  address: "Main Road, Sukher, Udaipur 313001",
};

export const CATALOGUE_URL = "/assets/celestraone-catalogue.pdf";

export const CATALOGUE_SPECS = {
  thickness: "20mm | 30mm",
  types: "Slab | Prefab for projects",
  finishes: "Polished | Honed | Leathered",
  sizes: "Custom slab sizes as per available lot sizes",
  dispatch: "Dispatch within 30 days",
  moq: "MOQ: 1 container per design",
};

export const HERO_VIDEO =
  "https://videos.pexels.com/video-files/38039550/16144893_3840_2160_24fps.mp4";

export const HERO_POSTER =
  "https://images.unsplash.com/photo-1551458601-14e8150ece4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const IMAGES = {
  quarry:
    "https://images.unsplash.com/photo-1551458601-14e8150ece4b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  factory:
    "https://images.unsplash.com/photo-1735494035457-b6e8f68b5248?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  granite:
    "https://images.unsplash.com/photo-1652305461546-bf0a76934433?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  marble:
    "https://images.unsplash.com/photo-1566041510394-cf7c8fe21800?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dolomite:
    "https://images.unsplash.com/photo-1494320964368-a5d425cc5928?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const PRODUCTS = [
  {
    key: "granite",
    name: "Granite",
    tagline: "Hard, dense and built for generations of use.",
    image: "/assets/stones/exotic-gold-granite.jpg",
    description:
      "Extracted from our own quarries, our granite blocks and slabs are cut and polished to a consistent finish. Suited to countertops, flooring, facades and heavy-traffic commercial spaces.",
    forms: ["Rough blocks", "Gangsaw slabs", "Cut-to-size tiles", "Polished & flamed finishes"],
    uses: ["Countertops & vanities", "Flooring & staircases", "Exterior cladding", "Monuments & landscaping"],
    series: [
      {
        name: "Premium Exotic Series",
        items: [
          { name: "Exotic Gold", img: "/assets/stones/exotic-gold-granite.jpg" },
          { name: "Arizona White", img: "/assets/stones/arizona-white-granite.jpg" },
          { name: "Alpine White", img: "/assets/stones/alpine-white-granite.jpg" },
          { name: "Beige Extra", img: "/assets/stones/beige-extra-granite.jpg" },
          { name: "Golden Glow", img: "/assets/stones/golden-glow-granite.jpg" },
          { name: "Monalisa", img: "/assets/stones/monalisa-granite.jpg" },
          { name: "Terry Gold", img: "/assets/stones/terry-gold-granite.jpg" },
          { name: "Dover White", img: "/assets/stones/dover-white-granite.jpg" },
          { name: "Titanium Gold", img: "/assets/stones/titanium-gold-granite.jpg" },
          { name: "Alaska Gold", img: "/assets/stones/alaska-gold-granite.jpg" },
          { name: "Cherry Red", img: "/assets/stones/cherry-red-granite.jpg" },
          { name: "Magma Gold", img: "/assets/stones/magma-gold-granite.jpg" },
          { name: "Lunar Mist", img: "/assets/stones/lunar-mist-granite.jpg" },
          { name: "Kiwi Onyx", img: "/assets/stones/kiwi-onyx-granite.jpg" },
          { name: "Auric Storm", img: "/assets/stones/auric-storm-granite.jpg" },
          { name: "Alaska Pink", img: "/assets/stones/alaska-pink-granite.jpg" },
          { name: "White Indo", img: "/assets/stones/white-indo-granite.jpg" },
          { name: "Cappucino", img: "/assets/stones/cappucino-granite.jpg" },
        ],
      },
      {
        name: "Superior Series",
        items: [
          { name: "Arizona White", img: "/assets/stones/arizona-white-granite.jpg" },
          { name: "Blue Dunes", img: "/assets/stones/blue-dunes-granite.jpg" },
          { name: "Cappuccino", img: "/assets/stones/cappuccino-granite.jpg" },
          { name: "Havana Blue", img: "/assets/stones/havana-blue-granite.jpg" },
          { name: "Lava Oro", img: "/assets/stones/lava-oro-granite.jpg" },
          { name: "Titanium Black", img: "/assets/stones/titanium-black-granite.jpg" },
          { name: "Marine Black", img: "/assets/stones/marine-black-granite.jpg" },
          { name: "Ander Black", img: "/assets/stones/ander-black-granite.jpg" },
        ],
      },
    ],
  },
  {
    key: "marble",
    name: "Marble",
    tagline: "Natural veining, honed to a luminous finish.",
    image: "/assets/stones/panda-white-marble.jpg",
    description:
      "Our marble range is selected block by block for colour consistency and vein character, then processed on precision cutting lines for slabs and tiles ready for premium interiors.",
    forms: ["Blocks", "Slabs", "Tiles", "Polished & honed finishes"],
    uses: ["Flooring & wall cladding", "Bathrooms & kitchens", "Hotel & lobby interiors", "Decorative stonework"],
    series: [
      {
        name: "Superior Series",
        items: [
          { name: "Fantasy Brown", img: "/assets/stones/fantasy-brown-marble.jpg" },
          { name: "Indian Statuario", img: "/assets/stones/indian-statuario-marble.jpg" },
          { name: "Mont Blanc", img: "/assets/stones/mont-blanc-marble.jpg" },
          { name: "Nero Calacatta", img: "/assets/stones/nero-calacatta-marble.jpg" },
          { name: "Panda White", img: "/assets/stones/panda-white-marble.jpg" },
          { name: "White Fantasy", img: "/assets/stones/white-fantasy-marble.jpg" },
        ],
      },
    ],
  },
  {
    key: "quartzite",
    name: "Quartzite",
    tagline: "Sparkling strength for statement surfaces.",
    image: "/assets/stones/gold-patagonia-quartzite.jpg",
    description:
      "Our quartzite collection brings crystalline texture and exceptional hardness to premium countertops, feature walls and flooring — exotic patterns with the durability of granite.",
    forms: ["Slabs", "Prefab for projects", "Custom slab sizes", "Polished, honed & leathered finishes"],
    uses: ["Kitchen countertops", "Feature walls", "Vanity tops", "High-traffic flooring"],
    series: [
      {
        name: "Superior Series",
        items: [
          { name: "Coastal Grey", img: "/assets/stones/coastal-grey-quartzite.jpg" },
          { name: "Cuiaba", img: "/assets/stones/cuiaba-quartzite.jpg" },
          { name: "Emporia Green", img: "/assets/stones/emporia-green-quartzite.jpg" },
          { name: "Pangea", img: "/assets/stones/pangea-quartzite.jpg" },
          { name: "Crystallo", img: "/assets/stones/crystallo-quartzite.jpg" },
          { name: "Gold Patagonia", img: "/assets/stones/gold-patagonia-quartzite.jpg" },
          { name: "Cosmopolitan Blue", img: "/assets/stones/cosmopolitan-blue-quartzite.jpg" },
          { name: "Patagonia Grey", img: "/assets/stones/patagonia-grey-quartzite.jpg" },
          { name: "Rose Levanto", img: "/assets/stones/rose-levanto-quartzite.jpg" },
          { name: "Patagonia Crystal", img: "/assets/stones/patagonia-crystal-quartzite.jpg" },
          { name: "Luios Blue", img: "/assets/stones/luios-blue-quartzite.jpg" },
          { name: "Grey Temptest", img: "/assets/stones/grey-temptest-quartzite.jpg" },
          { name: "Volcano", img: "/assets/stones/volcano-quartzite.jpg" },
          { name: "Zebrino", img: "/assets/stones/zebrino-quartzite.jpg" },
          { name: "Indian Taj Mahal", img: "/assets/stones/indian-taj-mahal-quartzite.jpg" },
          { name: "Grey", img: "/assets/stones/grey-quartzite.jpg" },
          { name: "Crytania", img: "/assets/stones/crytania-quartzite.jpg" },
          { name: "Bahama Blue", img: "/assets/stones/bahama-blue.jpg" },
          { name: "Fusion", img: "/assets/stones/fusion-quartzite.jpg" },
        ],
      },
    ],
  },
  {
    key: "tombstone",
    name: "Tomb Stone",
    tagline: "Enduring headstones & monuments, crafted to honour legacies.",
    image: "/assets/monuments/monument-01.jpg",
    description:
      "We specialize in crafting enduring headstones, monuments and memorial solutions designed to honor cherished legacies — precision-cut from premium granite and finished by hand at our facility.",
    forms: ["Headstones", "Monuments & memorials", "Custom designs", "Polished & carved finishes"],
    uses: ["Cemetery headstones", "Family monuments", "Memorial structures", "Custom commemorative work"],
    catalogue: "/assets/celestraone-monuments.pdf",
    series: [
      {
        name: "Headstones & Monuments Collection",
        items: Array.from({ length: 92 }, (_, i) => ({
          name: `Monument ${String(i + 1).padStart(2, "0")}`,
          img: `/assets/monuments/monument-${String(i + 1).padStart(2, "0")}.jpg`,
        })),
      },
    ],
  },
  {
    key: "dolomite",
    name: "Dolomite",
    tagline: "High-purity mineral for industry and construction.",
    image: "/assets/stones/dolomite-quarry.jpg",
    description:
      "Mined and graded at our own sites, our dolomite is supplied as lumps and processed material for steel, glass, agriculture and construction applications, with consistent quality across dispatches.",
    forms: ["Raw lumps", "Crushed & graded", "Powder", "Custom sizing on request"],
    uses: ["Steel & iron flux", "Glass manufacturing", "Soil conditioning", "Construction aggregates"],
    series: [
      {
        name: "Our Dolomite Range",
        items: [
          { name: "Raw Lumps", img: "/assets/stones/dolomite-lumps.jpg" },
          { name: "Dolomite Powder", img: "/assets/stones/dolomite-powder.jpg" },
          { name: "Quarry Face", img: "/assets/stones/dolomite-quarry.jpg" },
        ],
      },
    ],
  },
];

export const PLANT_IMAGES = [
  { name: "Gangsaw Cutting Line", img: "/assets/stones/plant-gangsaw.jpg" },
  { name: "Automated Polishing Line", img: "/assets/stones/plant-polishing.jpg" },
  { name: "Slab Yard & Gantry Crane", img: "/assets/stones/plant-yard.jpg" },
];

export const DOLOMITE_PLANT_IMAGES = [
  { name: "Crushing Plant", img: "/assets/stones/dolomite-plant-crusher.jpg" },
  { name: "Screening & Grading Station", img: "/assets/stones/dolomite-plant-screening.jpg" },
  { name: "Grinding Mill & Silos", img: "/assets/stones/dolomite-plant-mill.jpg" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/infrastructure", label: "Infrastructure" },
  { to: "/products", label: "Our Products" },
  { to: "/contact", label: "Contact Us" },
];
